<template>
  <div>
    <custom-page-table
      ref="table"
      rowKey="orderSupplierNo"
      query-path="directPresale/order/selectOrderList"
      base-key="directPresaleUrl"
      :queryParams="queryParams"
      :columns="getColumns()">
      <template slot="userSlot" slot-scope="rowItem">
        <div>{{ rowItem.record.orderContact }}</div>
        <div>{{ rowItem.record.orderMobile }}</div>
      </template>
      <template slot="stateSlot" slot-scope="rowItem">
        <div>{{ rowItem.record.orderState | orderDirectConnection }}</div>
      </template>
      <span slot="action" slot-scope="rowItem">
        <span v-if="rowItem.record.orderState==0 && rowItem.record.orderMethod==0">
          <a @click="confirmOrder(scope.record,1)">确认下单</a>
          <a @click="confirmOrder(scope.record,2)">拒绝订单</a>
        </span>
      </span>
    </custom-page-table>
    <a-modal :title="orderTypeId==1?'确认订单':'拒绝订单'" width="700px" :footer="null" :visible="visible"
             @cancel="handleCancel">
      <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item v-if="orderTypeId==1" label="下单方式" prop="orderMethod">
          <a-radio-group v-model="ruleForm.orderMethod">
            <a-radio :value="1">自动下单</a-radio>
            <a-radio :value="0">手动下单</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="备注">
          <a-textarea v-model="ruleForm.orderRemark" placeholder="备注" :auto-size="{ minRows: 3, maxRows: 5 }"/>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="offsetCol">
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading">保存设置</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'VirtualOrderConnection',
  data() {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 19 },
      offsetCol: { offset: 5 },
      columns: [
        {
          title: '直连订单号',
          dataIndex: 'orderSupplierNo'
        },
        {
          title: '商品名称',
          dataIndex: 'proName'
        },
        {
          title: '下单用户',
          dataIndex: 'orderContact',
          scopedSlots: { customRender: 'userSlot' }
        },
        {
          title: '订单状态',
          dataIndex: 'orderState',
          scopedSlots: { customRender: 'stateSlot' }
        },
        {
          title: '下单时间',
          dataIndex: 'createDate'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      queryParams: {
        merchantId: this.$store.getters.userInfo.merchantId,
        orderType: this.$route.query.serverUniqueId == 100017 ? 1 : 2
      },
      orderTypeId: undefined,
      ruleForm: {
        id: '',
        operatingType: undefined,//操作类型:1确单 2拒单 OrderNoticeStatusEnum 
        orderMethod: undefined,//订单下单方式 0手动(线下);1自动(直连) OrderMethodEnum 
        orderRemark: ''
      },
      submitLoading: false,
      visible: false,
      submitFormData: '',
      rules: {
        orderMethod: [
          { required: true, message: '请选择下单方式', trigger: 'change' }
        ]
      }
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'VirtualConnection', title: '商品绑定' },
      { name: 'VirtualOrderConnection', title: '订单直连' },
      { name: 'VirtualRelationAccount', title: '关联账号' }
    ])
  },
  methods: {
    getColumns() {
      if (this.$route.query.serverUniqueId == 100017) {
        return [
          {
            title: '直连订单号',
            dataIndex: 'orderSupplierNo'
          },
          {
            title: '商品名称',
            dataIndex: 'proName'
          },
          {
            title: '下单用户',
            dataIndex: 'orderContact',
            scopedSlots: { customRender: 'userSlot' }
          },
          {
            title: '订单状态',
            dataIndex: 'orderState',
            scopedSlots: { customRender: 'stateSlot' }
          },
          {
            title: '核销码',
            dataIndex: 'writeOffCode'
          },
          {
            title: '下单时间',
            dataIndex: 'createDate'
          },
          {
            title: '操作',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' },
            fixed: 'right'
          }
        ]
      } else {
        return [
          {
            title: '直连订单号',
            dataIndex: 'orderSupplierNo'
          },
          {
            title: '商品名称',
            dataIndex: 'proName'
          },
          {
            title: '下单用户',
            dataIndex: 'orderContact',
            scopedSlots: { customRender: 'userSlot' }
          },
          {
            title: '订单状态',
            dataIndex: 'orderState',
            scopedSlots: { customRender: 'stateSlot' }
          },
          {
            title: '下单时间',
            dataIndex: 'createDate'
          },
          {
            title: '操作',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' },
            fixed: 'right'
          }
        ]
      }

    },
    handleCancel() {
      this.visible = false
    },
    // 操作订单
    confirmOrder(data, typeId) {
      this.orderTypeId = typeId
      this.ruleForm.id = data.id
      this.ruleForm.operatingType = typeId
      this.visible = true
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    // 绑定商品
    submitData() {
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
      this.submitLoading = true
      this.getHttpServices().getDirectPresaleService().post('directPresale/order/operatingOrder', this.submitFormData).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.visible = false
        this.$message.success('操作成功')
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    }
  }
}
</script>
<style scoped></style>
